import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import BusinessDetails from "@/pages/BusinessDetails";
import Terms from "@/pages/Terms";
import Onboarding from "@/pages/Onboarding";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<BusinessDetails />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/onboarding" element={<Onboarding />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
